module.exports = __webpack_public_path__ + "static/img/建筑.53703e60.png";